import { UUID } from '@hfc/common/src/types/UUID';
import { APPLICATION_TYPES } from '@hfc/common/src/types/ApplicationTypes';
import { ChallengeQuestion } from '@/application/shared/domain/ChallengeQuestion';
import { EnrollmentRepository } from '@/application/shared/domain/EnrollmentRepository';
import { UseCase } from '@/shared/application/UseCase';
import { SfApiResponse } from '@hfc/ui-core';
import { ChallengeType } from '@/application/shared/domain/ChallengeQuestionSettings';
import { ChallengeQuestionResponse } from '@/application/shared/domain/ChallengeQuestionResponse';

export class ChallengeQuestionsOtpUseCase implements UseCase<[ChallengeQuestion, APPLICATION_TYPES, ChallengeType, UUID], SfApiResponse<ChallengeQuestionResponse>> {

  private repository: EnrollmentRepository;

  public constructor (repository: EnrollmentRepository) {
    this.repository = repository;
  }

  public async run (input: [ChallengeQuestion, APPLICATION_TYPES, ChallengeType, UUID]): Promise<SfApiResponse<ChallengeQuestionResponse>> {
    const [challengeQuestion, type, challengeType, uuid] = input;

    return await this.repository.challengeQuestionsOtp(challengeQuestion, type, challengeType, uuid);
  }

}
